<template>
  <form class="save-view" v-on:submit="save">
    <div class="mdl-card__supporting-text mdl-card--expand" v-bind:class="{ blurred: state == 'working' }"
         v-if="(state == 'ready') || (state == 'working')">

      <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label">
        <input class="mdl-textfield__input" type="text" id="fileName" v-model="fileName"
               v-bind:required="required" ref="fileName">
        <label class="mdl-textfield__label" for="fileName">{{ i18n().fileNamePlaceholder }}</label>
      </div>

      <div class="file-list-holder">
        <FileList v-bind:contentType="contentType" @selected="selected"></FileList>
      </div>

    </div>
    <div class="mdl-card__actions mdl-card--border" v-bind:class="{ blurred: state == 'working' }"
         v-if="state == 'ready' || state == 'working'">

      <button class="mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect"
        type="submit">
        <i class="material-icons">save</i> {{ i18n().saveToCloud }}
      </button>

      <button class="mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect"
        v-on:click="download">
        <i class="material-icons">file_download</i> {{ i18n().download }}
      </button>

    </div>
    <div class="working" v-if="state == 'working'">
      <div class="mdl-spinner mdl-js-spinner is-active"></div>
    </div>

    <div class="mdl-card__supporting-text mdl-card--expand done" v-if="state == 'done'">
      <p>{{ i18n().fileSaved(fileName) }}</p>
    </div>
    <div class="mdl-card__supporting-text mdl-card--expand error" v-if="state == 'error'">
      <p>{{ i18n().saveError(error) }}</p>
    </div>

    <div class="mdl-card__actions mdl-card--border" v-if="state == 'error' || state == 'done' ">
      <button class="mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect"
              v-on:click="close">
        <i class="material-icons">done</i> {{ i18n().ok }}
      </button>
    </div>

  </form>
</template>

<script>
  import FileList from "./FileList.vue"
  import { saveBlob } from "../../io/save"
  import api from "api"

  export default {
    name: 'save-view',
    props: {
      data: {
        default: function () {
          return []
        }
      },
      contentType: {
        type: String,
        default: function () {
          return "view"
        }
      },
      extension: {
        type: String,
        default: function () {
          return "sgf"
        }
      },
      defaultFileName: {
        type: String,
        default: function () {
          return "view"
        }
      }
    },
    components: {
      FileList
    },
    data () {
      return {
        fileName: "",
        state: "ready",
        error: null,
        required: false
      }
    },
    methods: {
      i18n() { return i18n().save },
      download() {
        const data = JSON.stringify(this.data, null, "  ")
        const blob = new Blob([data], {type: 'application/semgregate-filter'})
        const filename = (this.fileName.trim() != '' ? this.fileName.trim() : this.defaultFileName)
                         + "." + this.extension

        saveBlob(blob, filename)
      },
      save(e) {
        e.preventDefault()

        if(this.fileName.trim()=='') {

          this.required = true
          this.$refs.fileName.parentElement.setAttribute('class',
            this.$refs.fileName.parentElement.getAttribute('class')+' is-invalid')
          this.$refs.fileName.focus()

          return
        }

        this.state = "working"
        api.request(['save', 'save'], this.contentType, this.fileName, this.data).then(
          result => this.state = "done"
        ).catch(
          error => {
            this.error = error
            this.state = "error"
          }
        )

      },
      close() {
        this.$emit('close')
      },
      selected(file) {
        this.fileName = file.name
        this.$refs.fileName.parentElement.setAttribute('class',
          this.$refs.fileName.parentElement.getAttribute('class').replace('is-invalid','')+' is-focused')
      }
    },
    updated () {
      componentHandler.upgradeAllRegistered()
    },
    mounted () {
      componentHandler.upgradeAllRegistered()
    }
  }
</script>

<style scoped>
  .save-view {
    display: flex;
    flex-direction: column;
    min-height: 100px;
    position: relative;
  }

  .mdl-card__supporting-text {
    min-height: 60px;
  }

  .blurred {
    filter: blur(2px);
  }

  .mdl-textfield {
    width: 100%;
  }

  .mdl-card__actions button {
    float: right
  }

  .working {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    display: flex;
    text-align: center;
    align-items: center;
    background: rgba(255, 255, 255, 0.3);
  }
  .working div {
    margin: auto;
    height: 5em;
    width: 5em;
  }

  .done {
    display: flex;
    align-items: center;
  }
  .done p {
    font-size: 1.23em;
    text-align: center;
    margin: auto;
  }

  .error {
    color: darkred;
    display: flex;
    align-items: center;
  }
  .error p {
    font-size: 1.23em;
    text-align: center;
    margin: auto;
  }
</style>



// WEBPACK FOOTER //
// SaveView.vue?b2ecd9ae